<template>
  <div class="input input--search">
    <input type="search" :value="value" :placeholder="placeholder" class="input__field" v-on:keyup="onChange" />
  </div>
</template>

<script>
  export default {
    name: 'input-search',
    props: ['placeholder'],
    computed: {
      value(){
        return this.$store.state.formats.searchFilter
      }
    },
    methods: {
      onChange(e){
        let value = e.target.value;
        this.$store.commit('formats/setSearchFilter', value);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/InputSearch.vue